import styled from '@emotion/styled'
import tw from 'twin.macro'

export const ProductName = styled.div`
  ${tw`flex flex-col pl-2`}
  p {
    ${tw`pl-3`}
  }
`

export const Container = styled.div`
  ${tw`flex justify-between pb-6 pt-6 `}
`
export const ProductDetailsWrapper = styled.div`
  ${tw`flex pl-3`}
`
export const PriceDetailsWrapper = styled.div`
  ${tw`pr-8`}
`

export const SingleSelect = styled.div`
  > label {
    ${tw`w-auto`}
  }
`
